export const movie = {
  state: {
    S_searchResult: [],
    S_skeletonLoading: true,
    S_dialog: false,
    S_favorite: [],
    S_favBtn: false,
    isImageLoaded: true,
    S_movieInFav: false,
  },
  getters: {},
  mutations: {
    M_searchResult(state, payload) {
      state.S_searchResult = payload;
    },
    M_changeSkeletonLoading(state, payload) {
      state.S_skeletonLoading = payload;
    },
    M_enableDialog(state, payload) {
      state.S_dialog = payload;
    },
    M_addToFavorite(state, payload) {
      let isIn = state.S_favorite.find((el) => {
        return el == payload;
      });
      if (!isIn && payload != undefined) {
        state.S_favBtn = true;
        setTimeout(() => {
          state.S_favBtn = false;
        }, 3000);
        // console.log("added?", payload);
        // console.log(typeof payload);
        state.S_favorite.push(payload);
        state.S_movieInFav = true;
      }
      localStorage.setItem("favorites", JSON.stringify(state.S_favorite));
    },
    M_changeImageLoaded(state) {
      state.isImageLoaded = false;
      setTimeout(() => {
        state.isImageLoaded = true;
      }, 0);
    },
  },
  actions: {
    A_searchResult({ commit }, payload) {
      commit("M_searchResult", payload);
    },
    A_changeSkeletonLoading({ commit }, payload) {
      commit("M_changeSkeletonLoading", payload);
    },
    A_enableDialog({ commit }, payload) {
      commit("M_enableDialog", payload);
    },
    A_addToFavorite({ commit }, payload) {
      commit("M_addToFavorite", payload);
    },
  },
};
